import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import {
  Box, Input, Menu, MenuItem, Typography,
} from '@mui/material';
import { Replacement } from '../../report-builder/filename-section';

const StyledInsertValue = styled(Typography)`
  color: #4baef8;
  cursor: pointer;
  font-size: 14px;
  font-family: inherit;
`;

const StyledSearchEngine = styled(Input)`
  height: 38px;
  font-size: 14px;
  margin : 5px 0px -5px 11px;
`;

const StyledLabelItem = styled(Typography)`
  color: #4baef8;
  font-weight: 600;
  mr: 0.5;
  font-size: 14px;
`;

const StyledValueItem = styled(Typography)`
  color: #aeb7bc;
  font-weight: 400;
  font-size: 14px;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  margin-left: 5px;
`;

interface Props {
  replacements: Replacement[];
  onChange: (value: string) => void;
}

const FilterReplacements = ({
  replacements, onChange,
}: Props) => {
  const [searchItem, setSearchItem] = useState<string>('');
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleInsertValue = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setSearchItem(value);
  };

  const filterMenuItems = (item: string) => (
    item.toLowerCase().includes(searchItem.toLowerCase())
  );

  const handleMenuItemClick = (value: string) => {
    handleClose();
    onChange(value);
  };

  return (
    <StyledInsertValue data-testid="insert-value-button" onClick={handleInsertValue}>
      Insert value...
      <Box onClick={(event) => event.stopPropagation()}>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          sx={{ maxWidth: '285px', height: '350px' }}
        >
          <StyledSearchEngine
            disableUnderline
            value={searchItem}
            placeholder="Search..."
            onChange={handleFilter}
            inputProps={{ style: { border: 'none' } }}
          />
          <Box onClick={(event) => event.stopPropagation()}>
            {replacements
              .filter(({ label }) => filterMenuItems(label))
              .map(({ label, value }) => (
                <MenuItem
                  key={label + value}
                  value={value}
                  onClick={() => handleMenuItemClick(value)}
                  sx={{ height: '40px', border: '0.5px solid #d4d4d4' }}
                >
                  <>
                    <StyledLabelItem>{label}</StyledLabelItem>
                    <StyledValueItem>{value}</StyledValueItem>
                  </>
                </MenuItem>
              ))}
          </Box>
        </Menu>
      </Box>
    </StyledInsertValue>
  );
};

export default FilterReplacements;
